import React from "react";
import { Icon, VStack } from "@commonsku/design-system";
import { LucideCircleCheckBig } from "lucide-react";
import { WorkflowAutomationModelType, WorkflowMessageReminderTaskMetadata, WorkflowTask } from "../../../types";
import { WorkflowConfigurationOptions } from "../catalog/configurationOptions";
import AutomationStepPanel from "./AutomationStepPanel";
import { AssigneeStrategySelect } from "./action-editors/AssigneeStrategySelect";
import { TaskPreview } from "./action-editors/TaskPreview";

export interface ActionsStepProps {
  tasks: WorkflowTask[];
  modelType: WorkflowAutomationModelType;
  configurationOptions: WorkflowConfigurationOptions;
  onChange: (task: WorkflowTask) => void;
}

const ConditionsIcon = () => (
  <Icon ariaHidden as={LucideCircleCheckBig} boxSize="6">
    {null}
  </Icon>
);

/**
 * Actions configuration panel.
 */
export const ActionsStep = ({
  tasks,
  modelType,
  configurationOptions,
  onChange,
}: ActionsStepProps) => {
  const handleAssigneeStrategyChange = (task: WorkflowTask, value: string) => {
    onChange({ ...task, metadata: { ...task.metadata, assignee_strategy: value } });
  };
  return (
    <AutomationStepPanel
      icon={<ConditionsIcon />}
      stepNumber={3}
      title="Actions"
    >
      {tasks.map((task) => {
        const taskOption = configurationOptions.task_options.find(
          (option) => option.type === task.type && option.model_type === modelType,
        );
        const metadata = task.metadata as WorkflowMessageReminderTaskMetadata;

        return (
          <VStack alignItems="flex-start" gap="4" width="full" key={task.workflow_task_id}>
            <AssigneeStrategySelect
              value={metadata.assignee_strategy}
              options={taskOption?.assignee_options ?? []}
              onChange={(value) => handleAssigneeStrategyChange(task, value)}
            />
            <TaskPreview
              messageText={metadata.message_text}
              dueInDays={metadata.due_in_days}
            />
          </VStack>
        );
      })}
    </AutomationStepPanel>
  );
};

export default ActionsStep;
